import { ProductsRepository } from '@lib/api/repository/products/products.repository';
import {
  CreateProductInput,
  CreateProductOfferInput,
  UpdateProductOfferInput,
} from '@lib/types';

export default class ProductsService {
  constructor(private repository: ProductsRepository) {}

  updateProduct(id: string, input: CreateProductInput) {
    return this.repository.updateProduct(id, input);
  }

  deleteOffer(id: string) {
    return this.repository.deleteOffer(id);
  }

  findStoreOffer(slug: string, id: string, signal?: AbortSignal) {
    return this.repository.findStoreOffer(slug, id, signal);
  }

  listStoreOffers(
    slug: string,
    page: number,
    signal?: AbortSignal,
    owner?: boolean,
  ) {
    return this.repository.listStoreOffers(slug, page, signal, owner);
  }

  list(
    filters?: { gameCode?: string; category?: string; search?: string },
    signal?: AbortSignal,
  ) {
    return this.repository.list(filters, signal);
  }

  findBySlug(gameCode: string, slug: string, signal?: AbortSignal) {
    return this.repository.findBySlug(gameCode, slug, signal);
  }

  propose(input: CreateProductInput) {
    return this.repository.propose(input);
  }

  listAdmin(page: number, signal?: AbortSignal) {
    return this.repository.listAdmin(page, signal);
  }

  setStatus(id: string, status: 'active' | 'paused') {
    return this.repository.setStatus(id, status);
  }

  listMyOffers(signal?: AbortSignal) {
    return this.repository.listMyOffers(signal);
  }

  createOffer(input: CreateProductOfferInput) {
    return this.repository.createOffer(input);
  }

  updateOffer(id: string, input: UpdateProductOfferInput) {
    return this.repository.updateOffer(id, input);
  }
}
